// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-moon-and-stars.svg';

export const MindBodyMoonAndStars = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
